import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh-button',
  template: `<button class="btn__primary" type="button" (click)="refreshPage()">
  <img src="../../assets/refresh.png" alt="refresh_btn" height="20px" width="20px">
</button>`
})
export class RefreshButtonComponent {
  refreshPage() {
    window.location.reload();
  }
}
